import userService from '../../services/userService';
import {
  kickUnlockCallRingtoneFromUserGesture,
  unlockCallRingtoneAudio,
} from '../../services/call/callRingtoneService';
import { CONSENT_TYPES, getCookieConsent } from '../../utils/config/cookies';
import { canSyncPushNotifications } from './pushEligibility';
import { enqueueFcmSync } from './fcmSyncCoordinator';
import { FCM_SYNC_REASONS } from './pushConstants';
import { requestWebPushPermissionFromUserGesture } from './pushPermission';

const defaultSyncOptions = () => ({
  isUserEligible: canSyncPushNotifications,
  updateFcmToken: userService.updateFcmToken,
});

/**
 * Request browser notification permission from a user gesture and sync the FCM token
 * when cookie consent allows push.
 *
 * Must be called from a click/tap handler — Safari and iOS will ignore it otherwise.
 *
 * @returns {Promise<'default' | 'granted' | 'denied' | 'unsupported'>}
 */
export const enableWebPushFromUserGesture = async (syncOptions = defaultSyncOptions()) => {
  // Same tap that opens the browser notification prompt — start silent playback
  // synchronously (Safari / iOS PWA lose the gesture after the first await).
  kickUnlockCallRingtoneFromUserGesture();

  const permission = await requestWebPushPermissionFromUserGesture();

  if (permission === 'granted') {
    // Allow on the native prompt can extend the gesture; retry unlock after grant.
    void unlockCallRingtoneAudio();

    if (getCookieConsent() === CONSENT_TYPES.ALL) {
      await enqueueFcmSync(syncOptions, { reason: FCM_SYNC_REASONS.USER_GESTURE });
    }
  }

  return permission;
};
